var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhotoCameraFilled = function SvgPhotoCameraFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M9.326 3.25a1.75 1.75 0 0 0-1.512.868L6.57 6.25H5A2.75 2.75 0 0 0 2.25 9v9A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V9A2.75 2.75 0 0 0 19 6.25h-1.576L16.13 4.097a1.751 1.751 0 0 0-1.5-.847H9.326Zm.445 7.448a3.237 3.237 0 1 1 4.578 4.578 3.237 3.237 0 0 1-4.578-4.578Zm-1.06-1.06a4.737 4.737 0 1 1 6.698 6.698A4.737 4.737 0 0 1 8.71 9.637Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhotoCameraFilled);
export default ForwardRef;